var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70799 3.91599C2.61693 3.91599 3.41599 3.11692 3.41599 2.20799C3.41599 1.29906 2.61693 0.5 1.70799 0.5C0.74912 0.5 0 1.24912 0 2.20799C0 3.16687 0.799061 3.91599 1.70799 3.91599Z",
    fill: "#0d4892"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70799 7.29297C0.74912 7.29297 0 8.04209 0 9.00096C0 9.95984 0.799061 10.709 1.70799 10.709C2.61693 10.709 3.41599 9.90989 3.41599 9.00096C3.41599 8.09203 2.61693 7.29297 1.70799 7.29297Z",
    fill: "#0d4892"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70799 14.084C0.74912 14.084 0 14.8331 0 15.792C0 16.7508 0.799061 17.5 1.70799 17.5C2.61693 17.5 3.41599 16.7009 3.41599 15.792C3.41599 14.883 2.61693 14.084 1.70799 14.084Z",
    fill: "#0d4892"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.ce9e932d0fa0b77530bf534ee0bb73c4.svg";
export { ForwardRef as ReactComponent };